module.exports = __webpack_public_path__ + "static/media/home-box1.29b9cb21.jpg";